





















































































































































import { Component, Mixins, Prop } from 'vue-property-decorator';
import { Step } from '@/interfaces/Step';
import { Phase } from '@/interfaces/Phase';
import { HhmmssRule } from '@/mixins/hhmmssRule';

@Component
export default class ModuleStepListStepTimeTab extends Mixins(HhmmssRule) {
  @Prop()
  restrictedUser!: boolean;

  @Prop()
  step!: Step;

  @Prop()
  defaultStep!: Step;

  @Prop()
  environmentSpecific!: number;

  private menu = {
    planned_startdate: false,
    planned_enddate: false
  };

  get showTimeWaring(): boolean {
    const startIncomplete =
      (this.step.planned_startdate && !this.step.planned_start) ||
      (!this.step.planned_startdate && this.step.planned_start);
    const endIncomplete =
      (this.step.planned_enddate && !this.step.planned_end) ||
      (!this.step.planned_enddate && this.step.planned_end);

    return !!(startIncomplete || endIncomplete);
  }

  get stepPhasePlaceholder() {
    const phase = this.$store.state.all_phases.find(
      (p: Phase) => p.id === this.defaultStep?.phase_id
    );
    if (phase?.name) return phase.name;
    return '';
  }

  get stepTypePlaceholder() {
    const type = this.$store.state.all_types.find((t: any) => t.id === this.defaultStep?.type_id);
    if (type?.name) return type.name;
    return '';
  }
}
